// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductEdit_wrapper__3dkD0"};